import { Component, inject, input } from '@angular/core';
import {CheckboxModule} from "primeng/checkbox";
import {TooltipModule} from "primeng/tooltip";

import {FormsModule} from "@angular/forms";
import {InputTextModule} from "primeng/inputtext";
import {PaginatorModule} from "primeng/paginator";
import {SplitButtonModule} from "primeng/splitbutton";
import {RadioButtonModule} from "primeng/radiobutton";
import {
    DataService
} from "../../../../service/data.service";
import {
    ProjectDescriptor,
    ProjectDescriptorCategory,
    ProjectDescriptorCategoryVariant
} from "../../../../api/project_schemas";
import {ProjectProfileGroup} from "../../../../api/db/entities/ProjectProfileGroup";
import {ProfileCheckboxComponent} from "./profile-checkbox/profile-checkbox.component";
import {ProfileRadioButtonComponent} from "./profile-radio-button/profile-radio-button.component";
import {ProfileTextboxComponent} from "./profile-textbox/profile-textbox.component";
import {ProfileLongTextboxComponent} from "./profile-long-textbox/profile-long-textbox.component";
import {ProfileNumberComponent} from "./profile-number/profile-number.component";

@Component({
    selector: 'project-descriptor',
    imports: [
        CheckboxModule,
        TooltipModule,
        FormsModule,
        InputTextModule,
        PaginatorModule,
        SplitButtonModule,
        RadioButtonModule,
        ProfileCheckboxComponent,
        ProfileRadioButtonComponent,
        ProfileTextboxComponent,
        ProfileLongTextboxComponent,
        ProfileNumberComponent
    ],
    templateUrl: './project-descriptor.component.html',
    styleUrl: './project-descriptor.component.scss'
})
export class ProjectDescriptorComponent {
    protected dataService = inject(DataService);

    readonly projectDescriptor = input.required<ProjectDescriptor>();
    readonly descriptorCategory = input.required<ProjectDescriptorCategory>();
    readonly profileGroup = input.required<ProjectProfileGroup>();
    readonly variant = input.required<ProjectDescriptorCategoryVariant>();

}
